const ENV = {
  production: {
    gwiHost: 'http://localhost:8181',
    websiteHost: 'http://localhost:8181',
    brickHost: 'http://localhost:8383',
    brickPath: '/brick',
    brickIndexFileName: 'index.html',
    analyticsHost: 'http://localhost:8383',
    superwidgetHost: 'http://localhost:8484',
    analyticsGWIHost: 'http://localhost:8181',
    debug: false,

    posterBrickPath: '/brick',
    ad300BrickPath: '/iab_300x250',
    adLeaderboardV1BrickPath: '/iab_728x90_leaderboard',
    publisherBrickPath: '/publisher',
  },

  development: {
    gwiHost: 'http://localhost:8181',
    websiteHost: 'http://localhost:8181',
    brickHost: 'http://localhost:9000',
    brickPath: '/',
    brickIndexFileName: 'index.html',
    analyticsHost: 'http://localhost:8383',
    superwidgetHost: 'http://localhost:8484',
    analyticsGWIHost: 'http://localhost:3000',
    debug: true,

    posterBrickPath: '/gwi-brick/dist',
    ad300BrickPath: '/gwi-ads/iab_300x250/dist',
    adLeaderboardV1BrickPath: '/gwi-ads/iab_728x90_leaderboard/dist',
    publisherBrickPath: '/gwi-ads/publisher/dist',
  },
};

export default ENV[process.env.NODE_ENV || 'development'];



// WEBPACK FOOTER //
// ./src/config/env.js